import { Symbol17xuwzgi5g8ve as Symbol } from '../../internal/Symbol.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_NullSurrogate_kt__n2yti9();
  return NULL;
}
var NULL;
var UNINITIALIZED;
var DONE;
var properties_initialized_NullSurrogate_kt_39v8bl;
function _init_properties_NullSurrogate_kt__n2yti9() {
  if (!properties_initialized_NullSurrogate_kt_39v8bl) {
    properties_initialized_NullSurrogate_kt_39v8bl = true;
    NULL = new (Symbol())('NULL');
    UNINITIALIZED = new (Symbol())('UNINITIALIZED');
    DONE = new (Symbol())('DONE');
  }
}
//region block: exports
export {
  get_NULL as get_NULL2w9d0rq01h4d4,
};
//endregion

//# sourceMappingURL=NullSurrogate.mjs.map
